const initAuthDetails = ({ commit }, payload) => {
  commit("initAuthDetails", payload);
}

export default {
  initAuthDetails
}
